<template>
  <div>
    <div class="row my-1">
      <div class="offset-4 col-8 d-flex">
        <input v-model="startDate" class="form-control form-control-sm mx-2" type="date">
        <input v-model="endDate" class="form-control form-control-sm mx-2" type="date">
        <button
          @click="$parent.getUriStats(startDate, endDate)"
          class="btn btn-sm btn-outline-info float-right mr-2"
        >Харах</button>
        <button
          @click="$parent.onDownloadExcel('uri_stat_excel', startDate, endDate)"
          class="btn btn-sm btn-outline-success"
        >Excel татах</button>
      </div>
    </div>
    <div v-if="uriStats.length == 0" class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
    <div class="stat-table">
      <div class="table-responsive">
        <table class="table table-top-campaign">
          <tbody>
            <tr v-for="(stat, i) in uriStats" :key="i">
              <td>{{ stat.statName }}</td>
              <td>
                <a class="uri-link" v-bind:href="stat.uriName" target="_blank">{{stat.uriName}}</a>
              </td>
              <td>{{ stat.count }}</td>
              <td class="progress-container">
                <div class="progress">
                  <div
                    class="progress-bar bg-info"
                    role="progressbar"
                    :style="{'width': calcPercentage(stat.count) + '%'}"
                    aria-valuemax="100"
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="text-center">{{ uriStatDate }}</div>
  </div>
</template>

<style>
.uri-link {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 250px;
}
</style>


<script>
export default {
  name: "UriAccess",

  props: ["uriStat", "start", "end"],

  watch: {
    uriStat: function() {
      this.makeData();
    }
  },

  created() {
    this.makeData();
  },

  data() {
    return {
      uriStats: null,
      uriStatDate: "",

      startDate: this.start,
      endDate: this.end
    };
  },

  methods: {
    makeData() {
      this.uriStats = this.uriStat.stat;
      this.uriStatDate = this.uriStat.startDate + " - " + this.uriStat.endDate;
    },

    calcPercentage(count) {
      return (count / this.uriStats[0].count) * 100;
    }
  }
};
</script>